import React, { createContext, useEffect, useState } from 'react';
import ExternalLinkDialog from './external-link-dialog';

interface ExternalLinkContextType {
  externalLink: string;
  open: boolean;
  setOpen: (open: boolean) => void;
  setExternalLink: (externalLink: string) => void;
}

export const ExternalLinkContext = createContext<ExternalLinkContextType | null>(null);

export const ExternalLinkProvider = ({ children }) => {
  const [externalLink, setExternalLink] = useState();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleClick = (event) => {
      const target = event.target.closest('a'); // Captura clics en cualquier <a>

      if (!target) return;

      const href = target.href;
      if (
        !href ||
        href.startsWith(window?.location?.origin) ||
        href.startsWith('https://www.crossborderxpress.com/') ||
        href.includes('s3.us-east-2.amazonaws.com') ||
        href.includes(process.env.GATSBY_PANAMERICAN_VOUCHER_URL)
      ) {
        return; // No hace nada si el enlace es interno, de crossborderxpress o de amazon s3
      }

      event.preventDefault(); // Evita que el navegador siga el enlace
      setExternalLink(href);
      setOpen(true);
    };

    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);

  return (
    <ExternalLinkContext.Provider value={{ externalLink, open, setOpen }}>
      {children}
      <ExternalLinkDialog />
    </ExternalLinkContext.Provider>
  );
};
